import React from "react";

const Nodata = () => {
  return (
    <div
      style={{
        marginLeft: "100px",
        fontSize: "larger",
        textAlign: "center",
        color: "green",
        font: "san-sarif",
      }}
    >
      <h1 style={{ color: "darkgreen", letterSpacing: "5px" }}>
        The Iteam in this range is not available.
      </h1>
    </div>
  );
};

export default Nodata;
